const GAME_STATUSES = {
  ended: 4,
  started: 3,
  scheduled: 2,
  anticipated: 1,
};

export const ANALYTICS = {
  EVENT_TYPES: {
    display: 'display',
    visit: 'visit',
  },
  CLICK_TYPES: {
    auto: 'auto',
    click: 'click',
    browser_click: 'browser-click'
  },
  ENTITY_TYPES: {
    competition: 1,
    competitor: 2,
    sport: 3,
    game: 4,
    athlete: 5
  },
  TAB_NAMES: {
    match: 'match',
    lineups: 'lineups',
    stats: 'stats',
    h2h: 'h2h',
    trends: 'insight',
    scores: 'scores',
    standings: 'standings',
    squad: 'squad',
    brackets: 'brackets',
    transfers: 'transfers',
    odds: 'odds',
    propositionBets: 'proposition-bets',
    matches: 'matches',
    fixtures: 'fixtures',
    results: 'results',
    recent: 'recent',
    details: 'details',
    history: 'history',
    pointByPoint: 'point_by_point',
    news: 'news',
    highlights: 'highlights'
  },
  GAME_STATUSES: {
    [GAME_STATUSES.scheduled]: 0,
    [GAME_STATUSES.ended]: 1,
    [GAME_STATUSES.started]: 2,
  },
  TOGGLE_STATUSES: {
    select: 'select',
    unselect: 'unselect',
  },
  DROPDOWN_STATUSES: {
    opened: 'opened',
    closed: 'closed',
  },
  IS_ODDS: {
    on: 1,
    off: 0,
    na: -1
  },
  THEMES:{
    dark: 1,
    light: 0
  },
  IS_NOTIFICATIONS: {
    on: 1,
    off: 0
  },
  IS_LIVE: {
    on: 1,
    off: 0,
  },
  MATCH_VIEW: {
    allMatches: 'all-matches',
    sortedMatches: 'sortedMatches'
  },
  IS_EXPANDED: {
    expended: 1,
    collapsed: 0
  },
  VENDORS_ID: {
    awsKinesis: 'c:awskinesi-MedahaVb',
    twitter: 'twitter',
    hotjar: 'c:hotjar',
    ga: 'c:googleana-4TXnJigR'
  },
  IS_STANDINGS_PAGE: {
    false: 0,
    true: 1
  }
};
